var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.stubPreloaderForm},[(!_vm.isVerticalModal)?_c('div',{class:_vm.$style.formStubHeader},[_c('div')]):_vm._e(),_c('StubPreloaderForm',{attrs:{"isVerticalModal":_vm.isVerticalModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }